/** Shared radio/checkbox styling — matches SurveyButton primary (`bg-black`). */
export const surveyChoiceInputClass = 'mt-0.5 h-5 w-5 shrink-0 accent-black';
